export const serviceTypes = [
  {
    description: "Motorcycle",
    key: "MOTORCYCLE",
    restrictions: "50 × 50 × 50 cm, 20 kg",
    imgSrc:
      "https://sg-oimg.lalamove.com/ops/prd/2021-05-10/5f2d88a3-f66c-0bd8-9dbe-f97babada239.png",
    specialRequest: [{ value: "THERMAL_BAG_1", description: "Food Delivery Box(Thermal bag)" }, { value: "CASH_ON_DELIVERY", description: "Cash on delivery" }],
  },
  {
    description: "Sedan",
    key: "CAR",
    restrictions: "100 x 90 x 75 cm, 100kg",
    imgSrc:
      "https://sg-oimg.lalamove.com/ops/prd/2021-05-10/b7d1c5c8-ae75-0b22-b6a3-7ac1409d1b1a.png",
    specialRequest: [],
  },
  {
    description: "SUV",
    key: "SUV",
    restrictions: "160 x 130 x 80 cm, 300kg",
    imgSrc:
      "https://sg-oimg.lalamove.com/ops/prd/2021-05-10/de1791e8-1cdc-d1d3-55d0-c24f4427b58b.png",
    specialRequest: [],
  },
  {
    description: "Hatchback",
    key: "MPV",
    restrictions: "115 × 115 × 80 cm, 100 kg",
    imgSrc:
      "https://sg-oimg.lalamove.com/ops/prd/2021-05-10/9ea5a781-ff55-ccc2-730d-338505e226f6.png",
    specialRequest: [],
  },
  {
    description: "Box Truck",
    key: "TRUCK330",
    restrictions: "170 × 150 × 170 cm, 1,000 kg",
    imgSrc:
      "https://sg-oimg.lalamove.com/ops/prd/2021-05-10/acfeec4c-17ad-f7ea-ac5a-0313e588f532.png",
    specialRequest: [],
  },
  {
    description: "Fence Truck",
    key: "TRUCK175",
    restrictions: "210 x 170 x 170 cm, 4,000 kg",
    imgSrc:
      "https://sg-oimg.lalamove.com/ops/prd/2021-05-10/e5a7528f-1c8a-aeb2-ad33-8d0a35739b95.png",
    specialRequest: [],
  },
  {
    description: "Pick-Up Truck",
    key: "PICK_UP_TRUCK	",
    restrictions: "190 x 170 x 200 cm, 1,100 kg",
    imgSrc:
      "https://sg-oimg.lalamove.com/ops/prd/2021-05-10/789d0452-999c-8671-5ed2-36eebee0f8bb.png",
    specialRequest: [],
  },
];
